export enum RegionType
{
    NC = 'NC'
}
